<template>
    <el-dialog
      title="请输入短信验证码"
      v-model="dialogVisible"
      width="400px"
      @close="handleClose"
      :z-index="9999"  
    >
      <div class="p-4 text-center">
        <p class="mb-4">短信已发送至您的手机，请输入验证码</p>
        <el-input
          v-model="smsCode"
          placeholder="请输入6位短信验证码"
          maxlength="6"
          show-word-limit
          class="w-full"
        />
      </div>
  
      <template #footer>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  import { message } from 'heyui.ext';
  import { Invoice } from '@/api/Invoice';
  
  const props = defineProps({
    visible: { type: Boolean, default: false },
    taskId: { type: String, default: '' },
  });
  
  const emit = defineEmits(['update:visible', 'success']);
  
  const dialogVisible = computed({
    get: () => props.visible,
    set: val => emit('update:visible', val),
  });
  
  const smsCode = ref('');
  
  const handleSubmit = async () => {
    if (!smsCode.value || smsCode.value.length !== 6) {
      message.warn('请输入有效的6位短信验证码');
      return;
    }
  
    try {
      // 提交给 RPA
      await Invoice.submitSmsCode(props.taskId, smsCode.value);
      
      message.success('验证码已提交');
      emit('success');
      emit('update:visible', false);
      smsCode.value = '';
    } catch (err) {
      message.error('提交失败：' + (err.msg || '请重试'));
    }
  };
  
  const handleClose = () => {
    smsCode.value = '';
    emit('update:visible', false);
  };
  </script>
